/* unplugin-vue-components disabled */import { render } from "./ai-multiselect.vue?vue&type=template&id=ffc0bef2&scoped=true"
import script from "./ai-multiselect.vue?vue&type=script&lang=js"
export * from "./ai-multiselect.vue?vue&type=script&lang=js"

import "./ai-multiselect.vue?vue&type=style&index=0&id=ffc0bef2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc0bef2"],['__file',"src/components/ai-chat-v2/ai-assistant/ai-input/ai-multiselect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffc0bef2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffc0bef2', __exports__)) {
    api.reload('ffc0bef2', __exports__)
  }
  
  module.hot.accept("./ai-multiselect.vue?vue&type=template&id=ffc0bef2&scoped=true", () => {
    api.rerender('ffc0bef2', render)
  })

}


export default __exports__